import { useQuery, useMutation } from "react-query";
import * as dashboard from "services/dashboard/dashboard";

export const useDashboardCount = () => {
  return useQuery("dashboardQuery", () => dashboard.DashboardCountData(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    refetchInterval: 2000,
  });
};
export const useDashboardSiteData = () => {
  return useQuery("dashboardQuerys", () => dashboard.DashboardSiteData(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    refetchInterval: 2000,
  });
};
export const useDashboardDropdown = () => {
  return useQuery("dashboardDropDownQuery", () => dashboard.DashboardDropdownData(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  }
  );
};

export const useDashboardmap = (id) => {
  return useQuery(["dashboardMap", id], () => dashboard.DashboardMap(id), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    refetchInterval: 2000,
  });
};

export const useEmployeeListByGatewaySerialNumber = () => {
  return useMutation((formData) => dashboard.EmployeeListByGatewaySerialNumber(formData));
}

export const useAlertData = () => {
  return useQuery("AlertData", () => dashboard.AlertData(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    refetchInterval: 2000,
  }
  );
};

export const useRevertAlert = (statusId) => {
  return useQuery(["revertAlert", statusId], () => dashboard.RevertAlertData(statusId), {
    retry: false,
    enabled: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
}

export const useLocationCount = () => {
  return useQuery("LocationCount", () => dashboard.LocationCount(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    refetchInterval: 2000,
  }
  );
};


// export const useDashboardEmplayee = () => {
//   return useQuery("dashboardDropDownQuery", () => dashboard.DashboardEmployeeData(), {
//     refetchOnReconnect: true,
//     refetchOnWindowFocus: false,
//   }
//   );
// };

export const useDashboardEmployee = (id) => {
  return useQuery(["dashboardDropDownQuery", id], () => dashboard.DashboardEmployeeData(id), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};